import v4 from 'uuid/v4';
import makePlainAction from '../../../../creators/actions/makePlainAction';
/**
 * Thunk that creates a modal. Action has the type `CREATE_MODAL`.
 *
 * @param  {Object} options The options for the creator function.
 * @param  {String} options.id The id for the modal.
 * @param  {String} options.key The key for the component to be rendered in
 *                            modal (normally defined in a modals.js file).
 * @param  {Object} options.extraProps props to be passed to the modal component.
 *
 * @public
 * @author Alex Kasemir and Connor Taylor
 * @example
 * dispatch(createModal({ key: `modalKey` }));
 */

var createModal = function createModal(_ref) {
  var key = _ref.key,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? v4() : _ref$id,
      _ref$extraProps = _ref.extraProps,
      extraProps = _ref$extraProps === void 0 ? {} : _ref$extraProps;
  var create = makePlainAction({
    model: "modal",
    verb: "create"
  });
  return function (dispatch) {
    return dispatch(create({
      data: {
        id: id,
        key: key,
        extraProps: extraProps
      }
    }));
  };
};
/** @component */


export default createModal;